export function stringToColor(name: string) {
    let hash = 0
    let i

    name = name.toUpperCase();

    /* eslint-disable no-bitwise */
    for (i = 0; i < name.length; i += 1) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = '#'

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff
        color += `00${value.toString(16)}`.slice(-2)
    }

    return color
}

function contrastColor(hex: string): string {
    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    // Calculate the luminance using the formula
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b

    // Return black for light colors and white for dark colors
    return luminance > 186 ? '#000000' : '#FFFFFF'
}

export function stringAvatar(label: string) {
    const color = stringToColor(label)
    const textColor = contrastColor(color)
    const split = label.split(' ')
    if (split.length > 1) {
        return {
            sx: {
                color: textColor,
                bgcolor: color,
                fontSize: 18,
                width: 32,
                height: 32,
            },
            children: `${split[0][0]}${split[1][0]}`.toUpperCase(),
            variant: "rounded",
        }
    } else if (split.length == 1) {
        return {
            sx: {
                color: textColor,
                bgcolor: color,
                fontSize: 18,
                width: 32,
                height: 32,
            },
            children: `${split[0][0]}`.toUpperCase(),
            variant: "rounded",
        }
    } else {
        return {
            sx: {
                color: textColor,
                bgcolor: color,
                fontSize: 18,
                width: 32,
                height: 32,
            },
            children: "",
            variant: "rounded",
        }
    }
}

export function emailAvatar(name: string | null) {
    let nameToSplit = name?.split('@')[0]
    let split = ['?']
    if (nameToSplit) {
        split = nameToSplit.split(' ')
        if (split.length <= 1) {
            split = nameToSplit.split('+')
        }
        if (split.length <= 1) {
            split = nameToSplit.split('.')
        }
    }
    name = name || '?'

    const bgcolor = stringToColor(name)
    const color = contrastColor(bgcolor)

    return {
        sx: {
            color,
            bgcolor,
        },
        children: split?.map(s => s.charAt(0).toUpperCase()).join(''),
    };
}
